import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { useAuth } from './composables/useAuth'
import './assets/style.css'

const app = createApp(App)
app.use(router)

const { initializeAuth } = useAuth()
initializeAuth()

app.mount('#app')

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').catch(err => {
    console.warn('Service Worker registration failed:', err)
  })
}
